import getAppInfo from "src/utils/app-Info";
import { getPrivacyCollectionAndUseUrl, getTermsOfServiceUrl } from "../constants";

/**
 * 로그인/회원가입 후 필수 동의 약관 코드
 * - 핀포인트/Taap/IFC: A001(이용약관)/A003(만 14세)/A005(개인정보)
 * - STPM(삼성전자): A002/A004/A006
 * 코드별 의미·문구·링크·정책 기획: https://pnpt.atlassian.net/wiki/spaces/DESIGN/pages/2011332721
 * 코드/리비전 레지스트리: https://pnpt.atlassian.net/wiki/spaces/MVPD/pages/582222027
 */
const AGREEMENT_CODES_BY_APP_TYPE = {
  STPM: { termsOfService: "A002", ageOver14: "A004", privacy: "A006" },
  DEFAULT: { termsOfService: "A001", ageOver14: "A003", privacy: "A005" },
} as const;

const getAgreementCodeSet = () => (getAppInfo().appType === "STPM" ? AGREEMENT_CODES_BY_APP_TYPE.STPM : AGREEMENT_CODES_BY_APP_TYPE.DEFAULT);

export type AgreementMeta = {
  // 동의 항목 라벨
  label: string;
  // 약관 본문 링크
  url?: string;
};

export const getAgreementCodes = (): string[] => Object.values(getAgreementCodeSet());

/**
 * 약관 코드별 표시 정보
 * 코드·링크 모두 서비스(appType)별로 다르므로 호출 시점에 결정
 */
export const getAgreementMeta = (): Record<string, AgreementMeta> => {
  const codes = getAgreementCodeSet();
  return {
    [codes.termsOfService]: { label: "서비스 이용약관 동의", url: getTermsOfServiceUrl() },
    [codes.ageOver14]: { label: "만 14세 이상입니다." },
    [codes.privacy]: { label: "개인정보 수집 및 이용 동의", url: getPrivacyCollectionAndUseUrl() },
  };
};
